import { cn } from '@mntn-dev/ui-utilities'
import type React from 'react'

type ListItemProps = React.HTMLAttributes<HTMLLIElement>

const ListItem = ({ className, ...props }: ListItemProps) => {
  return (
    <li
      className={cn('[&>ul]:py-1', '[&>ul]:text-white/60', className)}
      {...props}
    />
  )
}

export { ListItem, type ListItemProps }
